import { notify as n } from "@kyvg/vue3-notification";

const duration = 5000;

type NotifyType = "success" | "danger";

interface NotifyOptions {
  type?: NotifyType;
}

export const notify = (text: string, options?: NotifyOptions) => {
  n({ type: options?.type ?? "danger", text, duration });
};
